export default __webpack_public_path__ + "static/media/Area_privada_familia_back_izq.9b7ca9f0.jpg";